import { useState, useEffect, useContext } from "react";

import RefundList from "../refundList/RefundList";
import "../../components/detailedEvent/DetailedEvent.css";
import { AuthContext } from "../../context/auth";
import "./RefundRequest.css";
import axios from "axios";

const RefundRequest = () => {
  const { user } = useContext(AuthContext);

  const [activeTab, setActiveTab] = useState("refund");
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  const [currentPage, setCurrentPage] = useState(1);
  const [refundRequests, setRefundRequests] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const [searchTerm, setSearchTerm] = useState("");

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const userType = user?.activeRole;

  const guestId = userType === "guest" ? user?._id : null;

  useEffect(() => {
    const fetchRefundRequests = async () => {
      try {
        setLoading(true);

        if (!user?._id || !userType) return;
        const url = userType.includes("host")
          ? `/events/host/${user._id}/refund`
          : `/events/guest/${user._id}/refund`;

        const res = await axios.get(url);
        const data = res.data;

        if (data.successStatus) {
          setRefundRequests(data.refundRequests || []);
          // console.log("Fetched refund requests2:", data.refundRequests);
        } else {
          setRefundRequests([]);
        }
      } catch (err) {
        setError("Failed to load refund requests");
      } finally {
        setLoading(false);
      }
    };

    fetchRefundRequests();
  }, [user?._id, userType]);

  const pendingRefunds = refundRequests.filter(
    (r) => r.refundDetails.refundStatus === "pending"
  );

  const refundHistory = refundRequests.filter(
    (r) => r.refundDetails.refundStatus !== "pending"
  );

  const handleSearch = (e) => {
    setSearchTerm(e.target.value);
    setCurrentPage(1);
  };

  const handleRefundAction = async ({ eventId, refundId, action }) => {
    try {
      await axios.patch(`/event/${eventId}/refund/${refundId}`, {
        refundStatus: action,
      });

      setRefundRequests((prev) =>
        prev.map((r) =>
          r.refundDetails.refundId === refundId
            ? {
                ...r,
                refundDetails: {
                  ...r.refundDetails,
                  refundStatus: action,
                  responseDate: new Date().toISOString(),
                },
              }
            : r
        )
      );
    } catch (error) {
      // console.error("Refund action failed", error);
      alert("Failed to update refund status. Please try again.");
    }
  };

  const handleCancelRefund = async ({ eventId, refundId }) => {
    try {
      await axios.patch(
        `/event/${eventId}/refund/${refundId}/${guestId}/cancel`
      );

      setRefundRequests((prev) =>
        prev.filter((r) => r.refundDetails.refundId !== refundId)
      );

      alert("Refund request cancelled successfully.");
    } catch (error) {
      alert("Failed to cancel refund request. Please try again.");
    }
  };

  const renderTabs = () => (
    <div className="refund-detailed-event-tabs">
      <div className="refund-detailed-event-tabs-2">
        {/* <button
          className={`tab ${activeTab === "about" ? "active" : ""}`}
          onClick={() => setActiveTab("about")}
        >
          About Event
        </button> */}

        <button
          className={`tab-selector-tab ${
            activeTab === "refund" ? "active" : ""
          }`}
          onClick={() => setActiveTab("refund")}
        >
          Pending Refund
        </button>
        <button
          className={`tab-selector-tab ${
            activeTab === "history" ? "active" : ""
          }`}
          onClick={() => setActiveTab("history")}
        >
          History
        </button>
      </div>

      {/* Desktop Search and Download */}
      {/* {!isMobile && (
        <div className="refund-search-wrapper">
          <div className="search-container">
            <input
              type="text"
              placeholder="Search Here..."
              className="search-input"
              value={searchTerm}
              onChange={handleSearch}
            />
            <button className="search-btn">
              <svg
                width="16"
                height="16"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"
                  fill="currentColor"
                />
              </svg>
            </button>
          </div>
          <button className="download-btn">
            Download
            <svg
              width="16"
              height="16"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M19 9h-4V3H9v6H5l7 7 7-7zM5 18v2h14v-2H5z"
                fill="currentColor"
              />
            </svg>
          </button>
        </div>
      )} */}

      {/* Mobile Search and Download Icons */}
      {/* {isMobile && (
        <div className="mobile-actions">
          <button className="search-btn-mobile" title="Search">
            <svg
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"
                fill="currentColor"
              />
            </svg>
          </button>
          <button className="download-btn-mobile" title="Download">
            <svg
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M19 9h-4V3H9v6H5l7 7 7-7zM5 18v2h14v-2H5z"
                fill="currentColor"
              />
            </svg>
          </button>
        </div>
      )} */}
    </div>
  );

  return (
    <div className="wedding-event-manager">
      <div>Refund Request</div>

      {renderTabs()}

      {loading && <p>Loading refund requests...</p>}
      {error && <p>{error}</p>}

      {activeTab === "refund" && (
        <RefundList
          refunds={pendingRefunds}
          searchTerm={searchTerm}
          role={user.activeRole}
          onApprove={(refund) =>
            handleRefundAction({
              eventId: refund.eventId,
              refundId: refund.refundId,
              action: "accepted",
            })
          }
          onCancelRefund={handleCancelRefund}
          onDecline={(refund) =>
            handleRefundAction({
              eventId: refund.eventId,
              refundId: refund.refundId,
              action: "declined",
            })
          }
        />
      )}

      {activeTab === "history" && (
        <RefundList refunds={refundHistory} role={user?.activeRole} />
      )}
    </div>
  );
};

export default RefundRequest;
